async function getSize(image: string) {
  let y = 1;
  if (image.endsWith("==")) {
    y = 2;
  }
  const x_size = image.length * (3 / 4) - y;
  const size = x_size / 1024;
  return size.toFixed(2);
}

export default getSize;
